import React, { useState } from 'react';
import { X } from 'lucide-react';

export const SizeGuide = ({ isOpen, onClose, productTitle }) => {
  const [unit, setUnit] = useState('IN'); // 'IN' or 'CM'

  if (!isOpen) return null;

  // Exact data from your screenshot
  const sizeData = [
    { label: 'S', width: 22.8, length: 28.3 },
    { label: 'M', width: 23.8, length: 29 },
    { label: 'L', width: 24.8, length: 30 },
    { label: 'XL', width: 25.8, length: 30.8 },
    { label: '2XL', width: 26.8, length: 31.5 },
    { label: '3XL', width: 27.8, length: 32.3 },
  ];

  // Conversion Helper
  const formatVal = (val) => {
    if (unit === 'IN') return val;
    return (val * 2.54).toFixed(1);
  };

  return (
    <div className="sg-overlay" onClick={onClose}>
      <div className="sg-modal" onClick={(e) => e.stopPropagation()}>
        
        {/* HEADER */}
        <div className="sg-header">
          {/* REMOVED EXTRA QUOTES HERE */}
          <h2>{productTitle} SIZE GUIDE</h2>
          
          <div className="sg-header-right">
            <div className="unit-toggle">
              <button 
                className={unit === 'IN' ? 'active' : ''} 
                onClick={() => setUnit('IN')}
              >IN</button>
              <button 
                className={unit === 'CM' ? 'active' : ''} 
                onClick={() => setUnit('CM')}
              >CM</button>
            </div>
            <X className="close-icon" onClick={onClose} size={24} />
          </div>
        </div>

        {/* BODY */}
        <div className="sg-body">
          
          {/* IMAGE LEFT */}
          <div className="sg-image-col">
             <div className="sg-image-frame">
                <img 
                  src="https://imgproxy.fourthwall.com/mcO2b5B1bnxoHf4iGa80uSRvhdjc9LYB2vBoa6czdkk/w:1400/sm:1/enc/egCRCSzF1yq-ncYH/7uvZKZFd0EmKDH0W/Drd0nhfUni9iXmwr/EQTlSuVY7F5JpzyY/GUMamgrRWDSpmHMR/UQQ8j85q_C-WGAru/ihv6JyQdEap-kAdL/eGXjVvPjOvrPB0Aa/EGICKE_hSA54ODZE/-r5d67EKHHq9x0Hm/GZPVwVREGjxYX6uV/fWr7av4wusad20jx/OGma0slutJ2zm3Sv/Ax6tPA" 
                  alt="Size Guide Diagram" 
                />
             </div>
          </div>

          {/* TABLE RIGHT */}
          <div className="sg-table-col">
            <table className="sg-table">
              <thead>
                <tr>
                  <th>SIZE LABEL</th>
                  <th>WIDTH</th>
                  <th>LENGTH</th>
                </tr>
              </thead>
              <tbody>
                {sizeData.map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'row-dark' : 'row-light'}>
                    <td className="sg-size-label">{row.label}</td>
                    <td>{formatVal(row.width)}</td>
                    <td>{formatVal(row.length)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* FOOTER INFO */}
        <div className="sg-footer">
          <p className="sg-note">PLEASE NOTE MEASUREMENTS CAN VARY WITHIN 2 INCH, WHICH IS WITHIN OUR TOLERANCE</p>
          
          <div className="sg-instructions">
            <p><strong>A WIDTH</strong></p>
            <p>PLACE THE END OF THE TAPE AT THE SEAM UNDER THE SLEEVE AND PULL THE TAPE MEASURE ACROSS THE SHIRT TO THE SEAM UNDER THE OPPOSITE SLEEVE.</p>
            
            <p><strong>B LENGTH</strong></p>
            <p>PLACE THE END OF THE TAPE BESIDE THE COLLAR AT THE TOP OF THE TEE (HIGHEST POINT SHOULDER). PULL THE TAPE MEASURE TO THE BOTTOM OF THE SHIRT.</p>
          </div>
        </div>

      </div>
    </div>
  );
};